import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const DiscProblemsPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Disc Problems</h1>
        <section className="mb-8">
          <p>Disc problems, such as herniated or slipped discs, can cause significant back or neck pain and limit your mobility. These issues occur when the soft tissue between the vertebrae becomes damaged or displaced, often leading to nerve irritation. Natural therapies can help manage pain and promote healing without surgery.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Age-related wear and tear</li>
            <li>Sudden injury or trauma</li>
            <li>Repetitive strain</li>
            <li>Poor posture</li>
            <li>Heavy lifting</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Localized back or neck pain</li>
            <li>Pain radiating to arms or legs</li>
            <li>Numbness or tingling</li>
            <li>Muscle weakness</li>
            <li>Reduced flexibility</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use herbal oils, gentle therapies, and supportive exercises to reduce inflammation, relax muscles, and encourage disc healing. Our holistic care is designed to restore comfort and function, helping you return to daily activities naturally.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Non-surgical pain relief</li>
            <li>Reduces inflammation and swelling</li>
            <li>Improves mobility</li>
            <li>Personalized, gentle care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Practice safe lifting techniques</li>
            <li>Maintain a healthy weight</li>
            <li>Do regular stretching and strengthening exercises</li>
            <li>Use ergonomic furniture</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment heal a herniated disc?</strong>
            <p>A: While it may not "cure" the disc, it can greatly reduce pain and support healing.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe after surgery?</strong>
            <p>A: Yes, our therapies can aid recovery post-surgery.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How long before I feel better?</strong>
            <p>A: Many patients notice improvement within a few weeks.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from disc pain—book your natural therapy session today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default DiscProblemsPage; 